import styled from '@emotion/styled';
import { mainColors } from 'src/assets/colors';

export const HeaderWrapper = styled('div', { label: 'HeaderWrapper' })`
    display: flex;
    align-items: center;
    gap: 8px;
    margin: 0 0 16px 0;
`;

export const Title = styled('h3', { label: 'Title' })`
    margin: 0;
`;

export const InfoIconWrapper = styled('div', { label: 'InfoIconWrapper' })`
    position: relative;
    display: flex;
    align-items: center;
    cursor: pointer;
`;

export const Tooltip = styled('div', { label: 'Tooltip' })<{ show: boolean }>`
    position: absolute;
    left: 100%;
    top: 50%;
    transform: translateY(-50%);
    margin-left: 8px;
    padding: 8px 12px;
    background-color: ${mainColors.main.primary};
    color: ${mainColors.default.light};
    border-radius: 4px;
    font-size: 12px;
    font-weight: normal;
    opacity: ${({ show }): number => (show ? 1 : 0)};
    visibility: ${({ show }): string => (show ? 'visible' : 'hidden')};
    transition: opacity 0.2s ease;
    z-index: 10;
    width: 408px;
    white-space: normal;
`;
